import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StartCasePipe } from './start-case.pipe';

@NgModule({
  declarations: [StartCasePipe],
  imports: [CommonModule],
  exports: [StartCasePipe],
  providers: [StartCasePipe]
})
export class StartCaseModule { }
